import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {loginSaga, registerMFASaga, sendOtpMailSaga} from "./loginSaga";

export default function* loginWatcher() {
  yield takeLatest(ActionsTypes.LOGIN, loginSaga);
  yield takeLatest(ActionsTypes.REGISTER_MFA, registerMFASaga);
  yield takeLatest(ActionsTypes.SEND_OTP_MAIL, sendOtpMailSaga);

}
